var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sys-teacher-hub-modal",
    {
      attrs: {
        show: _vm.show,
        title: _vm.title,
        icon: "mdi-book-open-page-variant-outline",
      },
      on: {
        "update:show": function ($event) {
          return _vm.$emit("update:show", $event)
        },
      },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-4" },
        [
          _c("sys-teacher-attribution-table", {
            attrs: {
              teacher: _vm.teacher,
              "work-time": _vm.workTime,
              token: _vm.token,
              "hide-register": "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }